import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import moment from 'moment';
import { Link } from 'react-router';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import { enum as adminPermissions } from '../../../../../../../../enums/admin-permissions';
import withCheckPermission from '../../../../shared/check-permission-hoc';
import { queryToGoalsForRegion, queryToGoalsWithStatuses, queryToGoalsByManual } from '../../../shared/query-to-goals';

const isRocket = process.env.CPA_ENV === 'rocket';

const Table = ({
	check,
	intl,
	table,
	sortByColumn,
	sortByGroups,
	currentCurrency,
	isIndexing
}) => {
	return (
		<table className="stat-table">
			<Thead
				check={check}
				intl={intl}
				sortByColumn={sortByColumn}
				sortByGroups={sortByGroups}
				table={table}
				hideWhenNotCurrency={!currentCurrency}/>
			<tbody
				className={cn({
					'stat-table__body': true,
					'table-indexing': isIndexing,
					'statistics-table-indexing': isIndexing
				})}
			>
				{rows(table, check, intl, !currentCurrency)}
			</tbody>
		</table>
	);
};

const Thead = ({
	check,
	intl,
	table,
	sortByColumn,
	sortByGroups,
	hideWhenNotCurrency
}) => {
	const { groupsInfo, shouldShowGroupHeader, currentSortedColumn } = table;
	const rowSpan = shouldShowGroupHeader ? 1 : 2;
	const isProfitShown = check(adminPermissions.analyticsViewConversionsProfit);
	return (
		<thead className="stat-table__head">
			<tr className="stat-table__head-top font-roboto-medium">
				<th
					rowSpan={rowSpan}
					className={cn({
						'group-header--first': shouldShowGroupHeader,
						[`order order-direction--${groupsInfo[0]['direction']}`] : true
					})}
					onClick={sortByGroups.bind(null, groupsInfo[0]['index'])}>
					<span>{intl(groupsInfo[0]['title'])}</span>
				</th>
				{!isRocket && (
					<th colSpan="3"><span>{intl('Traffic')}</span></th>
				)}
				<th colSpan={!isRocket ? 6 : 12}><span>{intl('Conversions')}</span></th>
				<th colSpan={isRocket ? (hideWhenNotCurrency ? 2 : 3) : (hideWhenNotCurrency ? 6 : 7)}>
					<span>{intl('Coefficients')}</span>
				</th>
				{isProfitShown && (
					<th colSpan={2}>
						<span>{intl('Profit')}</span>
					</th>
				)}
				{(isRocket || !hideWhenNotCurrency) && (
					<th colSpan={hideWhenNotCurrency ? 3 : 4}><span>{intl('Revenue')}</span></th>
				)}
			</tr>

			<tr className="state-table__head-bottom">
				{ shouldShowGroupHeader && (
					<th
						rowSpan={rowSpan}
						className={cn({
							'group-header--second font-roboto-medium': true,
							[`order order-direction--${groupsInfo[1]['direction']}`] : true
						})}
						onClick={sortByGroups.bind(null, groupsInfo[1]['index'])}>
						<span>{intl(groupsInfo[1]['title'])}</span>
					</th>
				) }
				{/*traffic*/}
				{!isRocket && (
					<th onClick={sortByColumn.bind(null, 'hosts')}>
						<span className={cn({
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'hosts'
						})}>{intl('Hosts')}</span>
					</th>
				)}
				{!isRocket && (
					<th onClick={sortByColumn.bind(null, 'hits')}>
						<span className={cn({
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'hits'
						})}>{intl('Hits')}</span>
					</th>
				)}
				{!isRocket && (
					<th onClick={sortByColumn.bind(null, 'transitions')} className="modify__last-element-in-group">
						<span className={cn({
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'transitions'
						})}>T -&gt; L</span>
					</th>
				)}
				{/*conversions*/}
				{isRocket && (
					<th
						className='conversions__by_region__th'
						onClick={sortByColumn.bind(null, 'all_conversions')}
					>
						<span className={cn({
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'all_conversions'
						})}>
							ALL
						</span>
					</th>
				)}
				{isRocket && (
					<th
						className='conversions__by_region__th'
						onClick={sortByColumn.bind(null, 'europe_conversions')}
					>
						<span className={cn({
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'europe_conversions'
						})}>
							EUROPE
						</span>
					</th>
				)}
				{isRocket && (
					<th
						className='conversions__by_region__th'
						onClick={sortByColumn.bind(null, 'latin_conversions')}
					>
						<span className={cn({
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'latin_conversions'
						})}>
							LATIN
						</span>
					</th>
				)}
				{isRocket && (
					<th
						className='conversions__by_region__th'
						onClick={sortByColumn.bind(null, 'asia_conversions')}
					>
						<span className={cn({
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'asia_conversions'
						})}>
							ASIA
						</span>
					</th>
				)}
				{isRocket && (
					<th
						className='conversions__by_region__th'
						onClick={sortByColumn.bind(null, 'africa_conversions')}
					>
						<span className={cn({
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'africa_conversions'
						})}>
							AFRICA
						</span>
					</th>
				)}

				<th
					className={cn({ 'modify__border-left': isRocket })}
					onClick={sortByColumn.bind(null, 'accepted_conversions')}
				>
					<span className={cn({
						'icon-approved': true,
						'order--active': currentSortedColumn && currentSortedColumn['index'] === 'accepted_conversions'
					})} />
				</th>
				<th onClick={sortByColumn.bind(null, 'manual_conversions')}>
					<span className={cn({
						'icon-manual': true,
						'order--active': currentSortedColumn && currentSortedColumn['index'] === 'manual_conversions'
					})} />
				</th>
				{!isRocket && (
					<th onClick={sortByColumn.bind(null, 'rejected_approved_conversions')}>
						<span className={cn({
							'icon-approved-rejected': true,
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'rejected_approved_conversions'
						})} />
					</th>
				)}
				<th onClick={sortByColumn.bind(null, 'pending_conversions')}>
					<span className={cn({
						'icon-pending': true,
						'order--active': currentSortedColumn && currentSortedColumn['index'] === 'pending_conversions'
					})} />
				</th>
				<th onClick={sortByColumn.bind(null, 'declined_conversions')}>
					<span className={cn({
						'icon-rejected': true,
						'order--active': currentSortedColumn && currentSortedColumn['index'] === 'declined_conversions'
					})} />
				</th>
				<th onClick={sortByColumn.bind(null, 'total_conversions')}>
					<span className={cn({
						'icon-total': true,
						'order--active': currentSortedColumn && currentSortedColumn['index'] === 'total_conversions'
					})} />
				</th>
				<th
					onClick={sortByColumn.bind(null, 'invalid_conversions')}
					className="modify__last-element-in-group  modify__border-left">
					<span className={cn({
						'icon-invalid': true,
						'order--active': currentSortedColumn && currentSortedColumn['index'] === 'invalid_conversions'
					})} />
				</th>
				<th
					onClick={sortByColumn.bind(null, 'invalid_conversions')}
					className="modify__last-element-in-group  modify__border-left"
				>
					<span className={cn({'icon-autotrash': true})} />
				</th>

				{/*coefficients*/}
				{ !hideWhenNotCurrency && (
					<th onClick={sortByColumn.bind(null, 'epc')}>
						<span className={cn({
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'epc'
						})}>EPC</span>
					</th>
				) }

				{!isRocket && (
					<th onClick={sortByColumn.bind(null, 'crs')}>
						<span className={cn({
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'crs'
						})}>CRS%</span>
					</th>
				)}
				{!isRocket && (
					<th onClick={sortByColumn.bind(null, 'crl')}>
						<span className={cn({
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'crl'
						})}>CRL%</span>
					</th>
				)}
				<th onClick={sortByColumn.bind(null, 'approved')}>
					<span className={cn({
						'order--active': currentSortedColumn && currentSortedColumn['index'] === 'approved'
					})}>App%</span>
				</th>
				<th onClick={sortByColumn.bind(null, 'redeemed')} className="modify__last-element-in-group">
					<span className={cn({
						'order--active': currentSortedColumn && currentSortedColumn['index'] === 'redeemed'
					})}>Red%</span>
				</th>

				{/*profit*/}

				{isProfitShown && (
					<th onClick={sortByColumn.bind(null, 'profit_usd')}>
						<span className={cn({
							'revenue__approved': true,
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'profit_usd'
						})}>
							Total
						</span>
					</th>
				)}
				{isProfitShown && (
					<th
						className="modify__last-element-in-group"
						onClick={sortByColumn.bind(null, 'profit_per_app')}
					>
						<span className={cn({
							'revenue__approved': true,
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'profit_per_app'
						})}>
							Per app
						</span>
					</th>
				)}

				{/*revenue*/}

				{(isRocket && hideWhenNotCurrency) && (
					<th onClick={sortByColumn.bind(null, 'accepted_income_usd')}>
						<span className={cn({
							'revenue__approved': true,
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'accepted_income_usd'
						})}>
							Total
						</span>
					</th>
				)}
				{(isRocket && hideWhenNotCurrency) && (
					<th onClick={sortByColumn.bind(null, 'accepted_income_per_app')}>
						<span className={cn({
							'revenue__approved': true,
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'accepted_income_per_app'
						})}>
							Per app
						</span>
					</th>
				)}
				{(isRocket && hideWhenNotCurrency) && (
					<th
						className="modify__last-element-in-group"
						onClick={sortByColumn.bind(null, 'accepted_income_epl')}
					>
						<span className={cn({
							'revenue__approved': true,
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'accepted_income_epl'
						})}>
							EPL
						</span>
					</th>
				)}

				{ !hideWhenNotCurrency && (
					<th onClick={sortByColumn.bind(null, 'accepted_income')}>
						<span className={cn({
							'icon-approved': true,
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'accepted_income'
						})} />
					</th>
				) }

				{ !hideWhenNotCurrency && (
					<th onClick={sortByColumn.bind(null, 'pending_income')}>
						<span className={cn({
							'icon-pending': true,
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'pending_income'
						})} />
					</th>
				)}

				{ !hideWhenNotCurrency && (
					<th
						onClick={sortByColumn.bind(null, 'declined_income')}>
						<span className={cn({
							'icon-rejected': true,
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'declined_income'
						})} />
					</th>
				)}

				{ !hideWhenNotCurrency && (
					<th
						onClick={sortByColumn.bind(null, 'bonus')}
						className="modify__last-element-in-group">
						<span className={cn({
							'order--active': currentSortedColumn && currentSortedColumn['index'] === 'bonus'
						})}>Bonus</span>
					</th>
				)}

			</tr>
		</thead>
	);
};

Table.propTypes = {
	intl: PropTypes.func,
	table: PropTypes.object,
	sortByColumn: PropTypes.func,
	sortByGroups: PropTypes.func,
	currentCurrency: PropTypes.string,
	isIndexing: PropTypes.bool
};

Thead.propTypes = {
	intl: PropTypes.func,
	table: PropTypes.object,
	sortByColumn: PropTypes.func,
	sortByGroups: PropTypes.func,
	hideWhenNotCurrency: PropTypes.bool
};

const rows = (table, check, intl, hideWhenNotCurrency) => {
	const { rows, shouldShowGroupHeader, groupsInfo, mapDowToDays, dataForGoalsQuery } = table;
	const elements = [];

	if (rows.size) {
		for (let [title, value] of rows) {
			shouldShowGroupHeader && elements.push(groupHeader(title, groupsInfo[0], mapDowToDays, intl));
			elements.push(
				groupRow(
					check,
					value,
					shouldShowGroupHeader,
					groupsInfo,
					mapDowToDays,
					intl,
					dataForGoalsQuery,
					hideWhenNotCurrency
				)
			);
		}
	}

	return elements;
};

const groupHeader = (
	title,
	group,
	mapDowToDays,
	intl
) => (
	<tr key={title} className="group-header">
		<td colSpan="20">
			<div className="group-header__wrap">
				<span className="title">
					{ getModifyGroupTitle(title, group.index, mapDowToDays, intl) }
				</span>
				<span className="icon" />
			</div>
		</td>
	</tr>
);

const groupRow = (
	check,
	value,
	shouldShowGroupHeader,
	groups,
	mapDowToDays,
	intl,
	dataForGoalsQuery,
	hideWhenNotCurrency
) => {
	const isProfitShown = check(adminPermissions.analyticsViewConversionsProfit);

	return value.rows.map((row, index) => (
		<tr key={index} className={cn({'total-row': row['isTotal']})}>
			<td className={cn({
				'group modify__last-element-in-group': true,
				'modify__align-left': !shouldShowGroupHeader
			})}>
				<span className='group__text'>
					{ row['isTotal']
						? intl('Total')
						: shouldShowGroupHeader
							? getModifyGroupTitle(row[groups[1].index], groups[1].index, mapDowToDays, intl)
							: getModifyGroupTitle(row[groups[0].index], groups[0].index, mapDowToDays, intl) }
				</span>
			</td>
			{/*traffic*/}
			{!isRocket && (
				<td><span>{formatBreakToHundreds(row['hosts'])}</span></td>
			)}
			{!isRocket && (
				<td><span>{formatBreakToHundreds(row['hits'])}</span></td>
			)}
			{!isRocket && (
				<td className="modify__last-element-in-group">
					<span className="traffic__tl">
						<span>{formatBreakToHundreds(row['transitions'])}</span>
						<span className="traffic__tl-percents">
							{row['transitionPercent'] + '%'}
						</span>
					</span>
				</td>
			)}
			{/*conversions*/}
			{isRocket && (
				<td>
					<span className="conversions__by_region">{formatBreakToHundreds(row['all_conversions'])}</span>
				</td>
			)}
			{isRocket && (
				<td>
					<Link
						to={`/statistics/general?${queryToGoalsForRegion(dataForGoalsQuery, row, 'europe')}`}
						target='_blank'
					>
						<span className="conversions__by_region">{formatBreakToHundreds(row['europe_conversions'])}</span>
					</Link>
				</td>
			)}
			{isRocket && (
				<td>
					<Link
						to={`/statistics/general?${queryToGoalsForRegion(dataForGoalsQuery, row, 'latin')}`}
						target='_blank'
					>
						<span className="conversions__by_region">{formatBreakToHundreds(row['latin_conversions'])}</span>
					</Link>
				</td>
			)}
			{isRocket && (
				<td>
					<Link
						to={`/statistics/general?${queryToGoalsForRegion(dataForGoalsQuery, row, 'asia')}`}
						target='_blank'
					>
						<span className="conversions__by_region">{formatBreakToHundreds(row['asia_conversions'])}</span>
					</Link>
				</td>
			)}
			{isRocket && (
				<td>
					<Link
						to={`/statistics/general?${queryToGoalsForRegion(dataForGoalsQuery, row, 'africa')}`}
						target='_blank'
					>
						<span className="conversions__by_region">{formatBreakToHundreds(row['africa_conversions'])}</span>
					</Link>
				</td>
			)}
			<td className={cn({ 'modify__border-left': isRocket })}>
				<Link to={`/statistics/conversions?${queryToGoalsWithStatuses(dataForGoalsQuery, row, ['approved'])}`}>
					<span className="conversions__approved">{ formatBreakToHundreds(row['accepted_conversions'])}
					</span>
				</Link>
			</td>
			<td>
				<Link to={`/statistics/conversions?${queryToGoalsByManual(dataForGoalsQuery, row)}`}>
					<span className="conversions__manual">{formatBreakToHundreds(row['manual_conversions'])}</span>
				</Link>
			</td>
			{!isRocket && (
				<td>
					<Link to={`/statistics/conversions?${
						queryToGoalsWithStatuses(dataForGoalsQuery, row, ['approved'], { rejected_approved: true })
					}`}>
						<span className="conversions__rejected_approved">
							{formatBreakToHundreds(row['rejected_approved_conversions'])}
						</span>
					</Link>
				</td>
			)}
			<td>
				<Link to={`/statistics/conversions?${queryToGoalsWithStatuses(dataForGoalsQuery, row, ['pending'])}`}>
					<span className="conversions__pending">{formatBreakToHundreds(row['pending_conversions'])}</span>
				</Link>
			</td>
			<td>
				<Link to={`/statistics/conversions?${queryToGoalsWithStatuses(dataForGoalsQuery, row, ['rejected'])}`}>
					<span className="conversions__rejected">{formatBreakToHundreds(row['declined_conversions'])}</span>
				</Link>
			</td>
			<td className="modify__padding-right">
				<Link
					to={`/statistics/conversions?${queryToGoalsWithStatuses(
						dataForGoalsQuery,
						row,
						['approved', 'pending', 'rejected']
					)}`}>
					<span className="conversions__total">{formatBreakToHundreds(row['total_conversions'])}</span>
				</Link>
			</td>
			<td className="modify__last-element-in-group modify__border-left">
				<Link to={`/statistics/conversions?${queryToGoalsWithStatuses(dataForGoalsQuery, row, ['trash'])}`}>
					<span className="conversions__invalid">
						<span>{formatBreakToHundreds(row['invalid_conversions'])} </span>
						<span className="conversions__invalid-percents">{calculatePercent(row)}%</span>
					</span>
				</Link>
			</td>
			<td className="modify__last-element-in-group modify__border-left">
				<Link to={`/statistics/unacceptable-conversions`}>
					<span className="conversions__invalid">
						<span>{row['autotrash_count'] || null} </span>
					</span>
				</Link>
			</td>

			{/*coefficients*/}
			{ !hideWhenNotCurrency && (
				<td><span>{row['epc']}</span></td>
			) }

			{!isRocket && (
				<td><span>{row['crs']}</span></td>
			)}
			{!isRocket && (
				<td><span>{row['crl']}</span></td>
			)}
			<td><span>{row['approved']}</span></td>
			<td className="modify__last-element-in-group"><span>{row['redeemed']}</span></td>

			{/*profit*/}

			{isProfitShown && (
				<td>
					<span className="revenue__approved">
						{formatBreakToHundreds(parseFloat(row['profit_usd']).toFixed(0))}
					</span>
				</td>
			)}
			{isProfitShown && (
				<td className="modify__last-element-in-group">
					<span className="revenue__approved">
						{formatBreakToHundreds(parseFloat(row['profit_per_app']).toFixed(1))}
					</span>
				</td>
			)}

			{/*revenue*/}

			{(isRocket && hideWhenNotCurrency) && (
				<td>
					<span className="revenue__approved">
						{formatBreakToHundreds(parseFloat(row['accepted_income_usd']).toFixed(0))}
					</span>
				</td>
			)}
			{(isRocket && hideWhenNotCurrency) && (
				<td>
					<span className="revenue__approved">
						{formatBreakToHundreds(parseFloat(row['accepted_income_per_app']).toFixed(1))}
					</span>
				</td>
			)}
			{(isRocket && hideWhenNotCurrency) && (
				<td>
					<span className="revenue__approved">
						{formatBreakToHundreds(parseFloat(row['accepted_income_epl']).toFixed(1))}
					</span>
				</td>
			)}

			{ !hideWhenNotCurrency && (
				<td>
					<span className="revenue__approved">
						{formatBreakToHundreds(parseFloat(row['accepted_income']).toFixed(0))}
					</span>
				</td>
			)}

			{ !hideWhenNotCurrency && (
				<td>
					<span>
						{formatBreakToHundreds(parseFloat(row['pending_income']).toFixed(0))}
					</span>
				</td>
			) }

			{ !hideWhenNotCurrency && (
				<td>
					<span>
						{formatBreakToHundreds(parseFloat(row['declined_income']).toFixed(0))}
					</span>
				</td>
			) }

			{ !hideWhenNotCurrency && (
				<td className="modify__last-element-in-group">
					<span>
						{formatBreakToHundreds(parseFloat(row['bonus']).toFixed(0))}
					</span>
				</td>
			) }
		</tr>
	));
};

const getModifyGroupTitle = (title, groupIndex, mapDowToDays, intl) => {
	switch (groupIndex) {
		case 'date':
			return title ? moment(title).format('DD.MM.YYYY') : '-';
		case 'dow':
			return !Number.isNaN(+title) ? intl(mapDowToDays[title]) : '-';
		case 'hour':
			return !(isUndefined(title) || isNull(title)) ? `${title}:00 - ${++title}:00` : '-';
		default:
			return title || '-';
	}
};

const formatBreakToHundreds = value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');

const calculatePercent = row => {
	const percent = (Number(row.invalid_conversions) + Number(row.total_conversions)) / 100;
	const total = Number(row.invalid_conversions) / percent;

	return isNaN(total) ? 0 : total.toFixed(0);
};

export default withCheckPermission(Table);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/table/general/main.js